import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['selectAll', 'checkbox'];

  get _checked() {
    return this._enabled.filter((checkbox) => checkbox.checked);
  }

  get _enabled() {
    return this.checkboxTargets.filter((checkbox) => !checkbox.disabled && !checkbox.readOnly);
  }

  get _unchecked() {
    return this._enabled.filter((checkbox) => !checkbox.checked);
  }

  connect() {
    requestAnimationFrame(() => {
      if (!this.hasSelectAllTarget) {
        return;
      }

      this.refresh();
    });
  }

  submit() {
    if (this.element.requestSubmit) {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }

  toggleSelectAll(event) {
    event.preventDefault();
    const { target } = event;
    this._enabled.forEach((checkbox) => checkbox.checked = (checkbox.disabled || checkbox.readOnly) ? checkbox.checked : target.checked);
  }

  refresh() {
    const checkboxesCount = this._enabled.length;
    const checkboxesCheckedCount = this._checked.length;

    this.selectAllTarget.checked = checkboxesCheckedCount > 0;
    this.selectAllTarget.indeterminate = checkboxesCheckedCount > 0 && checkboxesCheckedCount < checkboxesCount;
  }
}
